import axios from "./axios-auth";

const addCategory = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/addcategory",
      method: "POST",
      data: payload,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        console.log("error in addCategory api", err);
      });
  });

const renameCategory = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/renamecategory",
      method: "POST",
      data: payload,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        console.log("error in renameCategory api", err);
      });
  });

const getCategory = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getcategories",
      method: "GET",
      params: params,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        console.log("error in getCategory api", err);
      });
  });

const deleteCategoryByID = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/deletecategorybyid",
      method: "DELETE",
      params: params,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        console.log("error in deleteCategoryByID api", err);
      });
  });

const getAllProducts = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getallproducts",
      method: "POST",
      data: payload,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        console.log("error in getAllProducts api", err);
      });
  });

const moveProductToCategory = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/moveproducttocategory",
      method: "PUT",
      data: payload,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        console.log("error in moveProductToCategory api", err);
      });
  });

const deleteProductByID = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/deleteproductbyid",
      method: "DELETE",
      params: params,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        console.log("error in deleteProductByID api", err);
      });
  });

const rebuildCategoryCache = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/rebuildcategorycache",
      method: "GET",
      params: params,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        console.log("error in rebuildCategoryCache api", err);
      });
  });

export {
  addCategory,
  renameCategory,
  getCategory,
  deleteCategoryByID,
  getAllProducts,
  moveProductToCategory,
  deleteProductByID,
  rebuildCategoryCache,
};
